import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "layout-notice stlye-home-card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "layout-head" }, " 次元站公告: ", -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "title" }

import { NCalendar } from "naive-ui";
import { useNotice } from '@/composables/useNotice'



export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let { list } = useNotice()

function navigate(OutLink: string) {
  window.open(OutLink)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list).data, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          onClick: ($event: any) => (navigate(item.OutLink))
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(item.Title), 1)
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})